// Auto-generated skeleton for User

import { ClientDatabase } from "./ClientDatabase";

export const User: Api.User = {
  id: 0,
  name: '',
  email: '',
  tos: false,
  privacy: false,
  profile_image: null,
  clientdatabases_count: 0,
  logins_count: 0,
  latest_login: 0,
  persons_count: 0,
  can_lia: false,
  is_admin: false,
  is_team: false,
  clientdatabases: [ClientDatabase],
  persons: [],
  team: null,
  welcome: null,
  create: null,
  updated: null,
};

